export default __webpack_public_path__ + "4272539907d12312e4657e81087f2764.svg";